<!--
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2023-11-23 17:56:46
 * @LastEditTime: 2024-01-02 13:54:58
 * @LastEditors: 赵大壮
-->
<template>
    <div ref="mainView" class="content" >      
      <video :width="videoWidth" :height="videoHeight" ref="mainVideo" id="mainVideo" autoplay muted  playsinline loop > </video>
      <div class="videoController" ref="videoController">
        <div class="videoControllerLeft">
            <div style="height:100%;">
                <img v-if="!playing" class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_play.png" title="播放" @click="actionChangePlay"/>
                <img v-else class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_pause.png" title="暂停" @click="actionChangePlay"/>
            </div>
            <div style="height:100%;">
                <img v-if="doSpeek" class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_mute_true.png" title="正在对讲" @click="actionChangeSpeek"/>
                <img v-else class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_mute_false.png" title="开启对讲" @click="actionChangeSpeek"/>
            </div>
            <div ref="viewVoice"  @mouseover="showVoice = true">
                <img v-if="voiceNum > 0" class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_voice_true.png" title="声音" @click="actionChangeVoice"/>
                <img v-else class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_voice_false.png" title="声音" @click="actionChangeVoice"/>
            </div>
            <img  class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_take_pic.png" title="截图" @click="actionTackPic"/>
            <!-- <img  class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_record.png" title="回放" @click="actionRecord"/> -->
        </div>
        <div class="videoControllerRight">
            <img   class="iconView" :style="{width:iconWidth+'px',height:iconWidth+'px'}" src="@/assets/icon/icon_video_full_screen_true.png" title="全屏" @click="actionChangeFullScreen"/>
        </div>
      </div>
      <div v-if="showVoice" class="viewChangeVoice" @blue="showVoice = false" :style="{left: voiceLeft+'px'}" @mouseover="showVoice = true"  @mouseleave="actionMouseOut" >
        <el-slider
            v-model="voiceNum"
            vertical
            @change="actionVoiceChange"
            height="90px">
        </el-slider>
      </div>
    </div>
  </template>
  
  <script>
  import Play from './WebrtcPlay.js'
  import Publish from './WebrtcPublish.js'
    export default {
      data() {
        return {
            mainPlay: null,
            videoWidth: 0,
            videoHeight: 0,
            iconWidth: 0,
            playing: false,
            doSpeek: false,
            isMute: false,
            roomSocket: null,
            videoStream: '',
            audoStream: '',
            playUrl: '',
            pushUrl: '',
            showVoice: false,
            voiceLeft: 0,
            voiceNum: 0,
            streams: '',
            push_audio: null
        }
      },
      created() {
        setTimeout(() => {
            this.startPlay()
        }, 1000)
        this.videoStream = this.videoCode
        this.audoStream = this.audoCode
        this.playUrl = this.wsUrl + '/play?closenotify=1&transport=udp'
        this.pushUrl = this.wsUrl + '/publish?type=push&talkto=' + this.audoStream + '&audiocodec=pcma&closenotify=1'
      },
      mounted() {
        this.videoWidth = this.$refs.mainView.offsetWidth - 5
        this.videoHeight = this.$refs.mainView.offsetHeight - 5
        this.iconWidth = this.$refs.videoController.offsetHeight * 0.5
        this.voiceLeft = this.$refs.viewVoice.offsetLeft + 45
        console.log('voiceLeft====', this.voiceLeft)
      },
      props: {
        videoCode: String,
        audoCode: String,
        wsUrl: String,
        mediaIp: String,
        mediaPort: String,
      },
      computed: {
      },
      watch: {
        'rkey': function (newValue, oldValue) {
            console.log('newValue', newValue)
        },
        'wsUrl': function (newValue, oldValue) {
            console.log('newValue', newValue)
        },
      },
      beforeDestroy(to, from, next) {
          // this.mainPlay.stopPlay()
          // this.push_audio.stopPush()
          // this.$refs.mainVideo.pause()
          // this.$refs.mainVideo.stop()
      },
      methods: {
        startPlay() {
          if (!this.mainPlay) {
            this.mainPlay = new Play(this.videoStream, 'gb28181', '主屏幕', this.playUrl, true, true, this.playAudioCallback, 'mainVideo')
            this.mainPlay.is_audioDelayFun = 0
            this.mainPlay.wsConnectPlay()
          }
        },
        playAudioCallback() {
            this.playing = true
              this.voiceNum = this.$refs.mainVideo.volume * 100
              console.log('当前音量：：：：', this.voiceNum)
        },
        // 播放/暂停
        actionChangePlay() {
            this.playing = !this.playing
            if (this.playing) {
                this.$refs.mainVideo.play()
            } else {
                this.$refs.mainVideo.pause()
            }
        },
        // 开启/关闭对讲
        actionChangeSpeek() {
          var that = this
            if (!this.doSpeek) {
                let constraints = {
                  video: false,
                  audio: true
                }
                navigator.mediaDevices.getUserMedia(constraints).then(stream => {
                  that.streams = stream
                  console.log('that.streams', that.streams)
                  that.push_audio = new Publish('talk' + this.audoCode, 'gb28181', '音频', stream, this.pushUrl, this.PublishAudioCallback)
                  console.log('that.push_audio', that.push_audio)
                  that.push_audio.wsConnectPublish()
                }).catch(error => { 
                  console.log('getUserMedia:::error:::', error.message)
                  if (error.message === 'Requested device not found') {
                    // TODO 为获取到设备
                    alert('未监测到麦克风')
                    if (this.push_audio) {
                      this.push_audio.stopPush()
                    }
                  }
                }).finally(function (info) {
                })
            } else {
              this.doSpeek = false
              if (this.push_audio) {
                this.push_audio.stopPush()
              }
            }
        },
        PublishAudioCallback(type) {
          if (type == 1) {
            console.log('推流成功！！！')
            this.doSpeek = true
          } else {
            // TODO 为获取到设备
            alert('该摄像头不支持对讲')
          }
        },
        // 声音
        actionChangeVoice() {
            this.showVoice = false
            if (this.voiceNum != 0) {
                this.voiceNum = 0
                this.$refs.mainVideo.volume = 0
            } else {
                this.voiceNum = 100
                this.$refs.mainVideo.volume = 1
            }
        },
        // 回放
        actionRecord() {
            this.$router.push({ name: 'videoRecord', query: { id: this.videoStream, mediaIp: this.mediaIp, mediaPort: this.mediaPort } })
        },
        // 全屏
        actionChangeFullScreen() {
            let video = this.$refs.mainVideo
            if (document.fullscreenElement === video) {
                let arr = ['exitFullscreen', 'webkitExitFullscreen', 'msExitFullscreen']
                let method = arr.find(item => document[item])
                method && document[method]()
            } else {
                let arr = ['requestFullscreen', 'webkitRequestFullscreen', 'msRequestFullscreen']
                let method = arr.find(item => video[item])
                method && video[method]()
            }
        },
        actionMouseOut() {
            console.log('鼠标离开')
            this.showVoice = false
        },
        actionVoiceChange() {
            this.$refs.mainVideo.muted = false
            console.log(Math.round(this.voiceNum) / 100)
            this.$refs.mainVideo.volume = Math.round(this.voiceNum) / 100
        },
        // 截图
        actionTackPic() {
          const canvas = document.createElement('canvas') //  创建canvas 用来截图
          // const video = document.getElementById("video"); //  创建video 用来存放被截图的视频
          const video = this.$refs.mainVideo
          const a = document.createElement('a')
          // const a = document.getElementById('a') //  用来自动下载图片保存到本地
          // video.setAttribute('crossOrigin', 'anonymous') //  支持跨域
          canvas.width = video.clientWidth
          canvas.height = video.clientHeight
          var ctx = canvas.getContext('2d')
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          const filename = 'image_' + new Date().getTime() + '.png'
          a.setAttribute('download', filename)
          a.href = canvas.toDataURL('image/png')
          a.click()
        }
      }
    }
  </script>
  
  <style lang="scss">
  .content {
    width:100%;
    height:100%;
    background:#000000;
    transform: translate(0);
  }
  .videoController{
    width: 100%;
    max-height: 10%;
    height:60px;
    position: fixed;
	left: 0;
	bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
	align-items: center;
  }
  .videoControllerLeft{
    display: flex;
    flex-direction: row;
	align-items: center;
    margin-left: 30px
  }
  .iconView{
    cursor: pointer;
    margin-right:20px;
  }
  .videoControllerRight{
    display: flex;
    flex-direction: row;
	align-items: center;
    margin-right: 30px
  }
  .viewChangeVoice{
    position: fixed;
	bottom: 10%;
    height: 120px;
    width: 40px;
    background-color: #000000;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    flex-direction: row;
	align-items: center;
  }
 .el-slider__bar{
    background-color: #2178CF;
  }
 .el-slider__button {
    border: 2px solid #2178CF;
  }
  </style>